const AnnotationDisplayMode = Object.freeze({
  ANNOTATED: 'ANNOTATED',
  ORIGINAL: 'ORIGINAL',
  UNANNOTATED: 'UNANNOTATED'
})
export default AnnotationDisplayMode
export type AnnotationDisplayModeStrings = typeof AnnotationDisplayMode[keyof typeof AnnotationDisplayMode]
// RESERVE BELOW
